module.exports = __webpack_public_path__ + "img/zhimei-case02.b94d76d8.jpeg";